
































import Vue from "vue";

const Path = "M 50 50\nm 0 -47\na 47 47 0 1 1 0 94\na 47 47 0 1 1 0 -94";

export default Vue.extend({
  name: "CirclePercent",
  props: {
    value: { type: Number },
    sum: { type: Number },
    title: { type: String },
    color: { type: String }
  },
  data() {
    return {
      Path
    };
  },
  computed: {
    persent() {
      // @ts-ignore
      return ((this.value / this.sum) * 295.31).toFixed(2);
    }
  }
});
